module.exports = __webpack_public_path__ + "static/media/leiria.0631cb27.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/assets/leiria.png
// module id = 546
// module chunks = 0